<template>
  <div class="floating-cart position-fixed" v-if="cartQuantity>0">
    <button type="button" class="floating-cart-btn rounded-circle bg-red shadow" @click="openCart()" :aria-label="cartAriaLabel">
      <img src="@/assets/shopping-cart.svg" alt="" aria-hidden="true" />
    </button>
    <span class="position-absolute count translate-middle badge rounded-pill bg-white red shadow-sm" aria-hidden="true">
      {{cartQuantity}}
    </span>
    <span class="visually-hidden" aria-live="polite" aria-atomic="true">{{ cartLiveMessage }}</span>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
export default {
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters([
      'cartQuantity'
    ]),
    cartAriaLabel() {
      const n = this.cartQuantity;
      if (n > 0) {
        return `עגלת קניות, ${n} פריטים`;
      }
      return 'עגלת קניות';
    },
    cartLiveMessage() {
      const n = this.cartQuantity;
      if (n > 0) {
        return `עגלת קניות עודכנה, ${n} פריטים`;
      }
      return '';
    },
  },
  methods: {
    openCart() {
      if (this.$isDesktop(true)) {
        this.$store.dispatch('showPopupWithUrl', '/orders/cart_panel');
      } else {
        this.$router.push('/orders/checkout');
      }
    }
  }
}
</script>
<style scoped>
.floating-cart {
  display: block;
  z-index: 500;
  left: 10px;
  bottom: 10px;
  width: 45px;
  height: 45px;
}

.floating-cart-btn {
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  padding: 10px;
  cursor: pointer;
  line-height: 0;
}

.count {
  left: 85% !important;
  top: 3px !important;
}
</style>
